import { productBrandStyles as styles } from "@insite/content-library/Components/ProductBrand";

styles.logoImage = {
    ...styles.logoImage,
    width: "100px",
    height: "30px",
};
